<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'WhereLikeFilter',
          label: 'Name',
          attributes: 'name'
        }
      ]"
      v-model="tableFilter"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <v-table
      :url="`/api/v1/circularMail/receiver/${id}`"
      :filter="tableFilter"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          type: 'LinkProfileCell',
          name: 'Kunde'
        },
        {
          attribute: 'received_messages.0.dialogMessageId',
          name: 'Dialog ID',
          type: 'DialogLink'
        },
        {
          attribute: 'received_messages.0.created_at',
          name: 'Empfangen am',
          type: 'DateTimeCell'
        }
      ]"
    >
    </v-table>
  </div>
</template>

<script lang="babel">

export default {
  data() {
    return {
      tableFilter: []
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
  },
}
</script>
